import React from 'react'
import * as PIXI from 'pixi.js'

const PixiVerify = (props) => {
  React.useEffect(() => {
    let pixi = document.getElementById("pixi")

    //Create Pixi canvas
    let renderer = new PIXI.Renderer({
      width: props.width || window.innerWidth,
      height: props.height || window.innerHeight,
      backgroundColor: 0x000000
    })
    pixi.appendChild(renderer.view)

    //Render scene
    draw(renderer)

    //Add event listeners
    const resizeToFit = () => {
      renderer.resize(window.innerWidth, window.innerHeight)
      draw(renderer)
    }
    window.addEventListener("resize", resizeToFit)
    pixi.addEventListener("click", (e) => {
      e.stopPropagation()
      unselectAllItems()
    })
    pixi.addEventListener("touchstart", (e) => {
      e.stopPropagation()
      unselectAllItems()
    })

    return (
      () => {
        window.removeEventListener("resize", resizeToFit)
      }
    )
  }, [])

  function draw(renderer) {
    let scene = new PIXI.Container()

    let container = new PIXI.Container()
    let bg = new PIXI.Sprite(props.images[0].texture)
    let scale = window.innerHeight / bg.height
    bg.scale.set(scale, scale)
    bg.x = window.innerWidth / 2 - bg.width / 2
    bg.y = window.innerHeight / 2 - bg.height / 2
    container.addChild(bg)

    for (let i = 1; i < props.images.length; i++) {
      let entity = new PIXI.Sprite(props.images[i].texture)
      entity.scale.set(0.5, 0.5)
      entity.x = window.innerWidth / 2 - entity.width / 2
      entity.y = window.innerHeight / 2 - entity.height / 2
      container.addChild(entity)
    }

    scene.addChild(container)
    renderer.render(scene)

    let pixi = document.getElementById("pixi")
    for (let i = pixi.children.length - 1; i >= 1; i--) {
      pixi.removeChild(pixi.childNodes[i])
    }
    for (let i = 0; i < props.items.length; i++) {
      let item = props.items[i]
      let itemDiv = document.createElement("div")
      itemDiv.style.position = "absolute"
      itemDiv.style.zIndex = 20
      itemDiv.style.left = bg.width * item.pos.x / 100.0 + (window.innerWidth - bg.width) / 2 + "px"
      itemDiv.style.top = bg.height * item.pos.y / 100.0 + "px"
      itemDiv.style.cursor = "pointer"
      itemDiv.classList.add("glow")
      itemDiv.addEventListener("click", (e) => {
        e.stopPropagation()
        unselectAllItems()
        selectItem(e, item)
      })
      pixi.appendChild(itemDiv)
    }
  }

  function selectItem(e, item) {
    let confirm = document.getElementById("confirm")
    let info = document.getElementById("info")
    let content = document.getElementById("info-content")

    e.target.classList.add("glow-gold")
    content.innerHTML =
      `<p><b style="color: gold; font-size: 3.5vw;">${item.name}</b></p>
      <img src=${item.url} class="item" />
      <p>${item.desc}</p>`
    confirm.dataset.selectedItem = item.name

    info.style.display = "block"
    //info.style.left = e.pageX + "px"
    //info.style.top = ((e.pageY + 20 > window.innerHeight - info.offsetHeight) ? (e.pageY - 20 - info.offsetHeight) : (e.pageY + 20)) + "px"
  }

  function unselectAllItems() {
    let confirm = document.getElementById("confirm")
    let info = document.getElementById("info")
    let content = document.getElementById("info-content")

    let selectedItemDivs = document.getElementsByClassName("glow-gold")
    for(let i = 0; i < selectedItemDivs.length; i++) {
      selectedItemDivs[i].classList.remove("glow-gold")
    }
    info.style.display = "none"
    content.innerHTML = ""
    confirm.dataset.selectedItem = ""
  }

  function handleVerify(e) {
    let alert = document.getElementById("alert")
    let input = e.target.dataset.selectedItem

    if (input === props.answer) {
      alert.innerHTML = "<h4 style='color: yellow;'>尋獲證物！</h4>"
      alert.style.display = "block"
      props.onVerified()
    } else if (input !== "") {
      input = ""
      alert.style.display = "block"
      setTimeout(() => alert.style.display = "none", 2000)
    }
    unselectAllItems("glow-gold")
  }

  return (
    <React.Fragment>
      <div
        id="pixi"
        style={{
          position: "absolute",
          zIndex: 1,
          width: "100%",
          height: "100%",
          backgroundColor: "Black",
          textAlign: "center",
          overflow: "hidden"
        }}
      />
      <div
        id="message"
        style={{
          position: "relative",
          zIndex: 2,
          width: "100%",
          textAlign: "center",
          color: "white",
          fontSize: "4vh",
          top: "30%"
        }}
      >
        請在廢墟中找出證物
      </div>
      <div
        id="alert"
        style={{
          color: "pink",
          position: "relative",
          zIndex: 2,
          width: "100%",
          textAlign: "center",
          fontSize: "3vh",
          top: "30%",
          display: "none"
        }}
      >
        好像不太重要，重新找找！
      </div>
      <div
        id="info"
        className="info"
        style={{
          position: "absolute",
          zIndex: 3,
          display: "none",
          width: "100vw",
          height: "auto",
          fontSize: "3vh",
          color: "White",
          textAlign: "center",
          bottom: "5vh",
        }}
      >
        <div className="close-btn" onClick={unselectAllItems}>x</div>
        <div id="info-content" style={{padding:"2vh 3vw"}}/>
        <div
          id="confirm"
          style={{backgroundColor: "rgba(0, 255, 255, 0.5)", color: "white", cursor: "pointer"}}
          data-selected-item=""
          onClick={handleVerify}
        >
          確認
        </div>
      </div>
    </React.Fragment>
  )
}

export default PixiVerify
